module.exports = {
    methods: {
        loadTemplate(id) {
            var vm = this;
            this.axios.get("/api/email/template/" + id).then(function (response) {
                vm.$eventHub.$emit('setMailer', response.data);
            });
        },
        addEmail: function (id, domain) {
            var vm = this;
            var data = '';
            Swal.fire({
                title: '<i class="icon icon-mail"></i> Create Email Address',
                confirmButtonText: '<i class="icon icon-create-circle"></i> Create Email',
                html:
                '<form autocomplete="off">' +
                    '<div class="input-group">' +
                        '<input id="swal-email" type="text" autofocus class="form-control" placeholder="frank" aria-describedby="append-domain" >' +
                        '<span class="input-group-addon" id="append-domain">@' + domain + '</span>' +
                    '</div>' +
                '</form>',
                // type: 'warning',
                preConfirm: function(email) {
                    return new Promise(function(resolve, reject) {
                        vm.axios.post('/email/create/' + id, {
                            type: 'email',
                            email: $('#swal-email').val(),
                        }).then(function (response) {
                            data = response.data;
                            resolve();
                        }).catch((error) => {
                            if (typeof error.response !== 'undefined') {
                                data = {
                                    message: error.response.data
                                };
                            } else {
                                data = {
                                    message: 'An unknown error occurred'
                                };
                            }
                            resolve();
                        });
                    })
                }
            }).then(function() {
                myAlert(data);
                vm.$eventHub.$emit(id + '-addressTableRefresh');
            });
        },
        addFwd: function (id, domain) {
            var vm = this;
            var data = '';
            Swal.fire({
                title: '<i class="icon icon-forward"></i> Create Email Forwarder',
                confirmButtonText: '<i class="icon icon-create-circle"></i> Create Forwarder',
                html:
                '<form autocomplete="off">' +
                '<div class="input-group">' +
                '<input id="swal-email" type="text" autofocus class="form-control" placeholder="from" aria-describedby="append-domain" >' +
                '<span class="input-group-addon" id="append-domain">@' + domain + '</span>' +
                '</div>' +
                '<input id="swal-toemail" type="text" class="form-control" placeholder="to@address.com" class="swal2-input">' +
                '</form>',
                // type: 'warning',
                preConfirm: function(email) {
                    return new Promise(function(resolve, reject) {
                        vm.axios.post('/email/create/' + id, {
                            type: 'forwarder',
                            email: $('#swal-email').val(),
                            fwdemail: $('#swal-toemail').val(),
                        }).then(function (response) {
                            data = response.data;
                            resolve();
                        });
                    })
                }
            }).then(function() {
                myAlert(data);
                vm.$eventHub.$emit(id + '-forwarderTableRefresh');
            });
        },
        addTemplate: function () {
            alert('Needs reintegration');
            var vm = this;
            var data = '';
            Swal.fire({
                title: '<i class="icon icon-mail"></i> Create Email Template',
                confirmButtonText: '<i class="icon icon-create-circle"></i> Create Template',
                html: '<div id="addTemplate"></div>',
                onOpen: function () {
                    vm.axios.get('/settings/email/templates/create').then(function (response) {
                        $('#addTemplate').html(response.data);
                        CKEDITOR.replace('htmlEditor');
                    });
                },
                // type: 'warning',
                preConfirm: function(email) {
                    return new Promise(function(resolve, reject) {
                        var formData = new FormData(document.getElementById('emailTemplateForm'));
                        formData.set('html', CKEDITOR.instances.htmlEditor.getData());
                        vm.axios.post('/settings/email/templates/store', formData).then(function (response) {
                            data = response.data;
                            resolve();
                        }).catch(function (response) {
                            console.log(response);
                            reject(response.data[0]);
                        });
                    })
                }
            }).then(function() {
                myAlert(data);
            });
        }
    }
};